import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { readCookie, writeCookie } from '@/tools/tools';
/**
 * getters
 */
export var getters = {
  addresslist: function addresslist(state) {
    return state.addresslist;
  }
};
/**
 * mutations
 */
export var mutations = {
  // 收货列表
  ADDRESSLIST: function ADDRESSLIST(state, payload) {
    state.addresslist = payload;
    writeCookie('addresslist', state.addresslist);
  },
  // 编辑收货地址
  ADDRESSEDIT: function ADDRESSEDIT(state, payload) {
    state.addressedit = payload;
    writeCookie('addressedit', state.addressedit);
  },
  // 新增时清空当前编辑地址
  CLEAREDITADDRESS: function CLEAREDITADDRESS(state) {
    state.addressedit = {};
    writeCookie('addressedit', state.addressedit);
  },
  // 清空选择地址
  CLEARESELECTADDRESS: function CLEARESELECTADDRESS(state) {
    state.addressselect = [];
  },
  // 选择收货地址
  SELECTADDRESS: function SELECTADDRESS(state, payload) {
    state.addressselect = payload;
  }
};
/**
 * actions
 */
export var actions = {
  setAddressList: function setAddressList(_ref, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('ADDRESSLIST', payload);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  addressEdit: function addressEdit(_ref2, payload) {
    var commit = _ref2.commit;
    commit('ADDRESSEDIT', payload);
  },
  clearEditAddress: function clearEditAddress(_ref3) {
    var commit = _ref3.commit;
    commit('CLEAREDITADDRESS');
  }
};
/**
 * state
 */
export var state = {
  addresslist: readCookie('addresslist') ? readCookie('addresslist') : [],
  addressedit: readCookie('addressedit'),
  addressselect: []
};
var namespaced = true;
export var address = {
  namespaced: namespaced,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};